import { useMutation } from "@apollo/client";
import { Button, Drawer, Form } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { CREATE_LEAD_OPPORTUNITY, UPDATE_LEAD_OPPORTUNITY } from "../../../../graphql/mutation";
import { AccessPermissionAction } from "../../../../library/constants";
import { checkAccessPermission } from "../../../../library/helpers";
import { getMobileView } from "../../../../redux/slices/isMobile";
import OpportunityFormWrapper from "../../OpportunityFormWrapper";

export function OpportunityDrawer({
  opportunityDrawer,
  setopportunityDrawer,
  refetch,
  crmIntegrationType,
  mode,
  titleContent,
  getLeads,
  showCancel,
  settings,
  // Active root opp_type tab — forwarded into the form so the opp-type
  // cascader filters by permission and defaults to this root in ADD.
  selectedOppTypeId,
}) {
  const isMobileView = useSelector(state => getMobileView(state));
  const [form] = Form.useForm();
  const canAddEditOpportunity = checkAccessPermission(
    AccessPermissionAction.LEAD_OPPORTUNITY_MANAGEMENT_ADD_EDIT
  );
  const [updateLeadOpportunity, { loading: updateLeadOpportunityLoader }] =
    useMutation(UPDATE_LEAD_OPPORTUNITY);
  const [createLeadOpportunity, { loading: createLeadOpportunityLoader }] =
    useMutation(CREATE_LEAD_OPPORTUNITY);
  return (
    opportunityDrawer.open && (
      <Drawer
        className="normal-popup"
        title={titleContent}
        width={isMobileView ? "100%" : "40%"}
        open={opportunityDrawer.open}
        onClose={() => setopportunityDrawer({ ...opportunityDrawer, open: false })}
        footer={
          <div className="flex-row-centered gap-1">
            <Button
              loading={updateLeadOpportunityLoader || createLeadOpportunityLoader}
              disabled={!canAddEditOpportunity}
              type="primary"
              onClick={() => form.submit()}
            >
              {mode === "ADD" ? "Add opportunity" : "Save Opportunity Info"}
            </Button>
            <Button
              onClick={() => {
                form.resetFields();
                setopportunityDrawer({ ...opportunityDrawer, open: false });
              }}
            >
              Cancel
            </Button>
          </div>
        }
      >
        <OpportunityFormWrapper
          lead={opportunityDrawer.item}
          mode={mode}
          form={form}
          refetch={() => refetch()}
          crmIntegration={crmIntegrationType}
          getLeads={getLeads}
          close={() => {
            form.resetFields();
            setopportunityDrawer({ ...opportunityDrawer, open: false });
          }}
          showCancel={showCancel}
          updateLeadOpportunity={updateLeadOpportunity}
          updateLeadOpportunityLoader={updateLeadOpportunityLoader}
          createLeadOpportunity={createLeadOpportunity}
          createLeadOpportunityLoader={createLeadOpportunityLoader}
          settings={settings}
          selectedOppTypeId={selectedOppTypeId}
        />
      </Drawer>
    )
  );
}
